import { gql } from "@apollo/client";

import { adminStatusFragment } from "src/graphql/anti-fraud/fragments/AdminStatusFragment.ts";
import { ruleExecutionDetailsFragment } from "src/graphql/anti-fraud/fragments/RuleExecutionDetailsFragment.ts";
import { scenarioVersionFragment } from "src/graphql/anti-fraud/fragments/ScenarioVersionFragment";
import { userFragment } from "src/graphql/anti-fraud/fragments/UserFragment.ts";

export const scenarioExecutionResultFragment = gql`
  fragment ScenarioExecutionResultFragment on ScenarioExecutionResult {
    id
    globalScore
    date
    mode
    scenarioVersion {
      ...ScenarioVersionFragment
    }
    alert {
      id
      adminStatus {
        ...AdminStatus
      }
    }
    triggeredBy {
      ...UserFragment
    }
    ruleExecutionDetails {
      ...RuleExecutionDetailsFragment
    }
  }

  ${scenarioVersionFragment}
  ${adminStatusFragment}
  ${userFragment}
  ${ruleExecutionDetailsFragment}
`;
